import React from "react";
import { toastr } from "react-redux-toastr";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { documentsService } from "services";
import { withTranslation } from "react-i18next";

class DocumentMoveModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			submitted: false,
			selectedFolder: -1,
			errors: {},
			storeFolders: [],
			storeFoldersLoading: true
		};
	}

	componentDidMount() {
		console.log('DocumentMoveModal mounted with props:', this.props);
		this.fetchStoreFolders();
	}

	fetchStoreFolders = () => {
		console.log('Fetching store folders...');
		console.log('Current folder ID:', this.props.currentFolderId, 'Type:', typeof this.props.currentFolderId);
		this.setState({ storeFoldersLoading: true });
		documentsService.getStoreFolders()
			.then(response => {
				console.log('Store folders response:', response);
				const folders = response.data || response || [];
				console.log('All folders:', folders);

				const currentFolderIdStr = String(this.props.currentFolderId);
				const availableFolders = folders.filter(folder => {
					const folderIdStr = String(folder.id);
					const shouldInclude = folderIdStr !== currentFolderIdStr;
					console.log(`Folder ${folder.name} (${folderIdStr}) vs current (${currentFolderIdStr}): ${shouldInclude ? 'INCLUDE' : 'EXCLUDE'}`);
					return shouldInclude;
				});

				console.log('Available folders:', availableFolders);

				this.setState({
					storeFolders: availableFolders,
					storeFoldersLoading: false
				});
			})
			.catch(error => {
				console.error("Error fetching store folders:", error);
				this.setState({
					storeFolders: [],
					storeFoldersLoading: false
				});
				toastr.error('Error', this.props.t('documents.folder.errorLoadingFolders'));
			});
	};

	handleChange = (e) => {
		const { name, value } = e.target;
		console.log('handleChange:', name, value);
		this.setState({
			[name]: value,
			errors: { ...this.state.errors, [name]: null }
		});
	};

	checkValidField = (fieldName) => {
		return this.state.submitted && this.state.errors[fieldName];
	};

	handleSubmit = (e) => {
		e.preventDefault();
		console.log('DocumentMoveModal handleSubmit called');
		this.setState({ submitted: true });

		const { selectedFolder } = this.state;
		const { attachment, currentFolderId, onMoveSuccess, t } = this.props;

		console.log('Submit data:', { selectedFolder, attachment, currentFolderId });

		if (selectedFolder === -1) {
			this.setState({
				errors: { selectedFolder: t('documents.moveModal.mustSelectDestination') }
			});
			return;
		}

		this.setState({ isLoading: true });

		documentsService.moveAttachment(currentFolderId, attachment.url, selectedFolder)
			.then(response => {
				console.log('Move response:', response);
				toastr.success(t('common.success'), t('documents.moveModal.documentMoved', { name: attachment.name }));
				if (onMoveSuccess) {
					onMoveSuccess();
				}
				this.props.handleClose();
			})
			.catch(error => {
				console.error('Error moving document:', error);
				toastr.error('Error', t('documents.moveModal.errorMoving'));
				this.setState({ isLoading: false });
			});
	};

	render() {
		const { attachment, handleClose, t } = this.props;
		const { isLoading, selectedFolder, errors, storeFolders, storeFoldersLoading } = this.state;

		const sortedFolders = [...storeFolders].sort((a, b) => a.name.localeCompare(b.name));

		return (
			<div>
				<div className="modal-body">
					<p className="intro-text">
						{t('documents.moveModal.selectDestination', { name: attachment.name })}
					</p>

					<FormGroup className="form-group" controlId="selectedFolder">
						<FormLabel>{t('documents.moveModal.destinationFolder')} <span className="label-required">*</span></FormLabel>
						<FormControl
							name="selectedFolder"
							onChange={this.handleChange}
							required
							value={selectedFolder}
							isInvalid={this.checkValidField("selectedFolder")}
							as="select"
							disabled={storeFoldersLoading}
						>
							<option value="-1">
								{storeFoldersLoading ? t('documents.upload.loadingFolders') : t('documents.moveModal.selectDestinationFolder')}
							</option>
							{sortedFolders.map(folder => (
								<option key={folder.id} value={folder.id}>{folder.name}</option>
							))}
						</FormControl>

						<FormControl.Feedback type="invalid">
							{errors.selectedFolder || t('documents.moveModal.selectDestinationFolder')}
						</FormControl.Feedback>
					</FormGroup>
				</div>

				<div className="modal-footer">
					<div className="d-flex justify-content-end gap-2">
						<button
							type="button"
							className="btn btn-secondary"
							onClick={handleClose}
							disabled={isLoading}
						>
							{t('common.cancel')}
						</button>
						<button
							type="button"
							className="btn btn-primary ml-2"
							disabled={isLoading}
							onClick={this.handleSubmit}
						>
							{isLoading ? t('documents.moveModal.moving') : t('documents.moveDocument')}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(DocumentMoveModal); 